export default __webpack_public_path__ + "static/media/HbFooterRight1.53957d91.svg";